<div
    class="app-container bg-page-bg text-text-primary light-texture"
    [attr.inert]="currentTerms() ? '' : null"
    [attr.aria-hidden]="currentTerms() ? 'true' : null"
>
    <app-toast></app-toast>
    <div class="app-content m-top-4">
        <main>
            <router-outlet></router-outlet>
        </main>
    </div>
</div>

<app-modal
    [isOpen]="!!currentTerms()"
    [closable]="false"
    size="large"
    title="Required Terms & Conditions"
>
    @if (currentTerms(); as terms) {
        <div class="agreement-modal flex flex-col gap-3 h-full min-h-0">
            <div class="flex items-start justify-between gap-3">
                <div>
                    <h2 class="text-base font-bold text-nav-dark">{{ terms.title }}</h2>
                    <p class="text-xs text-muted-foreground mt-1">
                        Version {{ terms.version }} | {{ terms.appliesTo.replace('_', ' ') }}
                    </p>
                </div>
                <span class="text-xs text-muted-foreground whitespace-nowrap">
                    {{ remainingSections() }} {{ remainingSections() === 1 ? 'section' : 'sections' }} remaining
                </span>
            </div>

            <div class="agreement-tabs" role="tablist" aria-label="Terms sections">
                @for (section of terms.descriptions; track $index; let sectionIndex = $index) {
                    <button
                        type="button"
                        role="tab"
                        class="agreement-tab"
                        [class.agreement-tab-active]="activeSectionIndex() === sectionIndex"
                        [class.agreement-tab-complete]="sectionsAccepted()[sectionIndex]"
                        [disabled]="sectionIndex > 0 && !sectionsAccepted()[sectionIndex - 1]"
                        [attr.aria-selected]="activeSectionIndex() === sectionIndex"
                        (click)="selectSection(sectionIndex)"
                    >
                        <span class="agreement-tab-number">
                            @if (sectionsAccepted()[sectionIndex]) {
                                <i class="fa fa-check" aria-hidden="true"></i>
                            } @else {
                                {{ sectionIndex + 1 }}
                            }
                        </span>
                        <span>{{ section.title }}</span>
                    </button>
                }
            </div>

            <div class="agreement-sections flex flex-col min-h-0">
                @if (terms.descriptions[activeSectionIndex()]; as section) {
                    <section class="agreement-section">
                        <h3 class="text-sm font-bold text-nav-dark">{{ section.title }}</h3>
                        <div
                            #termsSection
                            class="agreement-copy"
                            (scroll)="onSectionScroll(activeSectionIndex(), $event)"
                            tabindex="0"
                            [attr.aria-label]="section.title + ' terms content'"
                        >
                            <ul class="pl-5 list-disc space-y-2">
                                @for (line of section.description; track $index) {
                                    <li>{{ line }}</li>
                                }
                            </ul>
                        </div>

                        <label class="agreement-check" [class.agreement-check-disabled]="!sectionsRead()[activeSectionIndex()]">
                            <input
                                type="checkbox"
                                [checked]="sectionsAccepted()[activeSectionIndex()]"
                                [disabled]="!sectionsRead()[activeSectionIndex()]"
                                (change)="setSectionAccepted(activeSectionIndex(), $event)"
                            />
                            <span>{{ section.acceptance }}</span>
                        </label>
                        @if (!sectionsRead()[activeSectionIndex()]) {
                            <span class="text-xs text-amber-badge-text">Scroll to the end of this section to continue.</span>
                        }

                        @if (section.optionalConsents?.length) {
                            <div class="flex flex-col gap-2 pt-2 border-t border-border">
                                <span class="text-xs font-semibold text-muted-foreground">Optional consents</span>
                                @for (consent of section.optionalConsents; track $index) {
                                    <label class="agreement-check">
                                        <input type="checkbox" />
                                        <span>{{ consent }}</span>
                                    </label>
                                }
                            </div>
                        }

                    </section>
                }
            </div>

            <div class="flex items-center justify-between gap-3 pt-3 border-t border-border">
                <div class="flex items-center gap-3 min-w-0">
                    @if (activeSectionIndex() > 0) {
                        <button type="button" (click)="previousSection()" class="agreement-back">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Previous
                        </button>
                    }
                    <span class="text-xs text-muted-foreground">All sections must be read and accepted.</span>
                </div>
                @if (activeSectionIndex() < ((terms?.descriptions || [])?.length || 0) - 1) {
                    <button
                        type="button"
                        (click)="nextSection()"
                        [disabled]="!sectionsAccepted()[activeSectionIndex()]"
                        class="agreement-submit"
                    >
                        Continue <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                } @else {
                    <button
                        type="button"
                        (click)="acceptCurrentTerms()"
                        [disabled]="!canAcceptCurrentTerms() || loaders.acceptingTerms()"
                        class="agreement-submit"
                    >
                        {{ loaders.acceptingTerms() ? 'Signing...' : 'Agree & Continue' }}
                    </button>
                }
            </div>
        </div>
    }
</app-modal>